import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

type TQuery = {
  pageNumber: number;
  size: number;
  currency?: string;
  startDate?: string;
  endDate?: string;
  searchValue?: string;
  FunderId?: number;
  aggregatorId?: number;
  dateSearchMode?: number;
  investmentStatus?: number;
};

const getAllInvestment = async ({
  pageNumber,
  size,
  currency,
  startDate,
  endDate,
  searchValue,
  FunderId,
  aggregatorId,
  dateSearchMode,
  investmentStatus,
}: TQuery) => {
  let queryParams = `?Page=${pageNumber}&PageSize=${size}`;

  if (currency) {
    queryParams = `${queryParams}&Currency=${currency}`;
  }
  if (startDate) {
    queryParams = `${queryParams}&from_date=${startDate}`;
  }
  if (endDate) {
    queryParams = `${queryParams}&to_date=${endDate}`;
  }
  if (searchValue) {
    queryParams = `${queryParams}&FunderName=${searchValue}`;
  }
  if (FunderId) {
    queryParams = `${queryParams}&FunderId=${FunderId}`;
  }
  if (aggregatorId) {
    queryParams = `${queryParams}&AggregatorId=${aggregatorId}`;
  }
  if (dateSearchMode) {
    queryParams = `${queryParams}&DateSearchMode=${dateSearchMode}`;
  }
  if (investmentStatus) {
    queryParams = `${queryParams}&InvestmentStatus=${investmentStatus}`;
  }
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.GET_ALL_INVESTMENTS}${queryParams}`,
  );

  return data;
};

export default function useAllInvestment({
  pageNumber,
  size,
  startDate,
  endDate,
  searchValue,
  FunderId,
  aggregatorId,
  currency,
  dateSearchMode,
  investmentStatus,
}: TQuery) {
  return useQuery(
    [
      {
        pageNumber,
        size,
        startDate,
        endDate,
        searchValue,
        FunderId,
        aggregatorId,
        currency,
        dateSearchMode,
        investmentStatus,
      },
      "getAllInvestment",
    ],
    getAllInvestment,
  );
}
